import { useQuery } from "@tanstack/react-query";
import { fetchProductsByCategory } from "@/lib/api";

interface Product {
  Id: number;
  Title: string;
  Category: number;
}

interface ProductResponse {
  list: Product[];
  pageInfo?: {
    totalRows: number;
  };
}

export function useProducts(selectedCategories: Record<number, string>) {
  const { data, isLoading } = useQuery<Record<string, Product[]>>({
    queryKey: ["products", Object.values(selectedCategories)],
    queryFn: async () => {
      const categoryIds = Object.values(selectedCategories).filter(id => id);
      if (categoryIds.length === 0) return {};
      
      const results = await Promise.all(
        categoryIds.map(async (categoryId) => {
          const data = await fetchProductsByCategory(categoryId);
          return { [categoryId]: data?.list || [] };
        })
      );
      
      return Object.assign({}, ...results);
    },
    enabled: Object.keys(selectedCategories).length > 0,
  });

  const getProductsForItem = (index: number): Product[] => {
    const categoryId = selectedCategories[index];
    return data?.[categoryId] || [];
  };

  const isLoadingProductsForItem = (index: number): boolean => {
    const categoryId = selectedCategories[index];
    return !!categoryId && isLoading;
  };

  return {
    getProductsForItem,
    isLoadingProductsForItem,
  };
}
